import { RECEIVE_ALL_MODELS } from '../actions/model_actions';
var _ = require('lodash')
const models_reducer = (oldState = {}, action) => {
    Object.freeze(oldState);
    switch (action.type) {
        case RECEIVE_ALL_MODELS:
            const models = _.mapKeys(action.models, "_id")
            let normalizedModels = { ...oldState, ...models }
            return normalizedModels
        default:
            return oldState;
    }
};

export default models_reducer;